




























































































import Vue from "vue";
import TarifCovidLayout from "@/@modules/tarif-covid/components/Layout.vue";
import { GraphqlService } from "../../services";
import { RunRef } from "../../interfaces/RunRef";
import { Period } from "../../interfaces/Period";
import ConfirmModalVue from "../../modals/ConfirmModal.vue";
export default Vue.extend({
  components: {
    TarifCovidLayout,
  },
  data() {
    return {
      loading: false,
      origin: undefined,
      valid: false,
      runRef: {
        of: {
          code: undefined,
        },
        nr: undefined,
      } as RunRef,
      periods: [] as Period[],
      filters: {
        origin: ["IO_100", "IO_200", "IO_300", "IO_400", "IO_500", "IO_200", "IO_600", "IO_900", "CIN", "NIHDI"],
        period: [],
        run: [],
      } as any,
      headers: [
        { text: "tarif-covid.origin", value: "origin" },
        { text: "tarif-covid.run", value: "run" },
        { text: "tarif-covid.flow", value: "flow" },
        { text: "tarif-covid.send", value: "send" },
        { text: "tarif-covid.flowNbr", value: "flowNbr" },
        { text: "tarif-covid.recordNbr", value: "recordNbr" },
        { text: "tarif-covid.doubleNbr", value: "doubleNbr" },
        { text: "tarif-covid.toUse", value: "toUse" },
      ],
      sendConfig: [] as any,
    };
  },
  async mounted() {
    await this.init();
    this.refreshRuns();
    await this.refresh();
  },
  computed: {
    getRunRef(): any {
      if (this.runRef.of?.code && this.runRef.nr) {
        return this.runRef;
      } else {
        return undefined;
      }
    },
    getItems(): any {
      return this.sendConfig.flatMap((sendConfig: any) => {
        return {
          origin: sendConfig.origin,
          run: sendConfig.run.nr,
          period: sendConfig.run.of.code,
          flow: sendConfig.flow,
          send: sendConfig.send,
          flowNbr: sendConfig.flowMessageCount,
          recordNbr: sendConfig.recordCound,
          doubleNbr: sendConfig.doubleRecordCount,
          toUse: sendConfig.use,
        };
      });
    },
  },
  methods: {
    async init() {
      this.periods = await GraphqlService.getPeriods();
      this.filters.period = this.periods.flatMap(period => {
        return period.code;
      });
    },
    refreshRuns() {
      this.filters.run = this.periods
        .find(period => {
          return period.code == this.runRef.of?.code;
        })
        ?.runs?.flatMap(run => {
          return run.nr;
        });
    },
    async refresh() {
      this.sendConfig = await GraphqlService.getSendConfig(this.origin, this.getRunRef);
    },
    async updateSendConfig(item: any) {
      const confirmed: boolean = await this.$modal.show<boolean>(ConfirmModalVue);
      if (confirmed) {
        await GraphqlService.updateSendConfig({
          run: { of: { code: item.period }, nr: item.run } as RunRef,
          flow: item.flow,
          origin: item.origin,
          send: item.send,
          use: !item.toUse,
        });
        this.refresh();
      }
    },
  },
});
